<template>
    <div>
      <div v-if="isLoading" class="dt-loading">
        <b-spinner variant="default" size="sm" class="align-middle"></b-spinner>
        <p>Loading data...</p>
      </div>
      <div v-else>
        <RStDailyGraph v-if="columns.length > 0" ref="barlineGraph" @onZoomed="chartIndexUpdated" @onScrolled="chartIndexUpdated"
        :type="'PORT'" :data="assetObject[activeAssetId]" :customHeight=320 :isDailyReport=true :customXAxis="columns" />
             <b-table-simple small striped hover responsive class="text-center mt-2 font-weight-bold">
                <b-tbody>
                  <b-tr>
                    <b-td style="border: 1px solid black; width: 100px !important; font-size: 10px; background-color: #002a64 !important; color: white;">Hour</b-td>
                    <b-td style="border: 1px solid black; width: 40px !important; font-size: 10px; background-color: lightgray !important;"  v-for="hour in columns" v-bind:key="hour">{{hour}}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-td style="border: 1px solid black; width: 175px !important; font-size: 10px; background-color: #002a64 !important; color: white;">Avg AE Total Fuel Used</b-td>
                    <b-td style="border: 1px solid black; width: 40px !important;  font-size: 10px" v-for="(x, idx) in assetObject[activeAssetId].datas" v-bind:key="idx">{{roundValue(getAverageFuelConsumption(x.ae))}}</b-td>
                  </b-tr>
                  <b-tr v-if="Object.values(assetObject[activeAssetId].datas)[0].ae.AE1">
                    <b-td style="border: 1px solid black; width: 175px !important; font-size: 10px; background-color: #002a64 !important; color: white;">AE1 Total Fuel Used</b-td>
                    <b-td style="border: 1px solid black; width: 40px !important;  font-size: 10px" v-for="(x, idx) in assetObject[activeAssetId].datas" v-bind:key="idx">{{x.ae.AE1 ? roundValue(x.ae.AE1.fuelConsumption) : 0}}</b-td>
                  </b-tr>
                  <b-tr v-if="Object.values(assetObject[activeAssetId].datas)[0].ae.AE2">
                    <b-td style="border: 1px solid black; width: 175px !important; font-size: 10px; background-color: #002a64 !important; color: white;">AE2 Total Fuel Used</b-td>
                    <b-td style="border: 1px solid black; width: 40px !important;  font-size: 10px" v-for="(x, idx) in assetObject[activeAssetId].datas" v-bind:key="idx">{{x.ae.AE2 ? roundValue(x.ae.AE2.fuelConsumption) : 0}}</b-td>
                  </b-tr>
                  <b-tr v-if="Object.values(assetObject[activeAssetId].datas)[0].ae.AE3">
                    <b-td style="border: 1px solid black; width: 175px !important; font-size: 10px; background-color: #002a64 !important; color: white;">AE3 Total Fuel Used</b-td>
                    <b-td style="border: 1px solid black; width: 40px !important;  font-size: 10px" v-for="(x, idx) in assetObject[activeAssetId].datas" v-bind:key="idx">{{x.ae.AE3 ? roundValue(x.ae.AE3.fuelConsumption) : 0}}</b-td>
                  </b-tr>
                </b-tbody>
            </b-table-simple>
      </div>
    </div>
</template>
<script>
import RStDailyGraph from '@/components/directives/report-stacked-daily';
import dateUtil, { generateHourArray } from '@/util/date';
import { formatNum } from '@/util/number';

export default {
  name: 'AEFuelCons',
  props: ['assetObject', 'isLoading', 'activeAssetId', 'rangeRaw'],
  components: {
    RStDailyGraph,
  },
  data() {
    return {
      count: 0,
      cruiseUnit: 'km',
      flowUnit: 'lph',
      speedUnit: 'knot',
      dateParam: undefined,
      summary: {
        max: 0,
        min: 1000,
        avg: 0,
      },
      columns: [],
    };
  },
  mounted() {
    // this.avgCount();
    console.log('mounted summary asset>>>', this.assetObject);
    this.columns = generateHourArray(new Date(this.rangeRaw.start), new Date(this.rangeRaw.end));
  },
  methods: {
    roundValue(x) {
      if (x < 1 && x > 0) {
        return formatNum(x, 2);
      }

      return Math.round(x);
    },
    getAverageFuelConsumption(ae) {
      let totalFuelConsumption = 0;
      let numAes = 0;
      if (ae.AE1) {
        totalFuelConsumption += Number(ae.AE1.fuelConsumption);
        numAes++;
      }
      if (ae.AE2) {
        totalFuelConsumption += Number(ae.AE2.fuelConsumption);
        numAes++;
      }
      if (ae.AE3) {
        totalFuelConsumption += Number(ae.AE3.fuelConsumption);
        numAes++;
      }
      return numAes > 0 ? totalFuelConsumption / numAes : 0;
    },
    chartIndexUpdated(xaxis) {
      this.dateParam = dateUtil.byInterval('custom');
      this.dateParam.range = {};
      const timeIndex = Object.keys(this.assetObject[this.activeAssetId].datas);
      let updatedStart = timeIndex[xaxis.min];
      let updatedEnd = timeIndex[xaxis.max];
      if (!timeIndex[xaxis.min]) {
        updatedStart = timeIndex[0];
      }
      if (!timeIndex[xaxis.max]) {
        updatedEnd = timeIndex[timeIndex.length - 1];
      }
      if (xaxis.min < 0) {
        const indexBefore = xaxis.min * -1;
        const interval = parseInt((parseInt(updatedEnd) - parseInt(updatedStart)) / timeIndex.length);
        updatedStart -= indexBefore * interval;
      }

      this.dateParam.range.start = parseInt(updatedStart) * 1000;
      this.dateParam.range.end = parseInt(updatedEnd) * 1000;
      this.dateParam.aggregatedUnit = 'MINUTE';
      this.onSubmitRange(this.dateParam);
      // console.log('Load data based on chart index: ', xaxis, timeIndex, timeIndex[xaxis.min], timeIndex[xaxis.max]);
    },
  },
};
</script>

<style lang="scss">
  .dt-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 9999;
    background: #DEE2E6;
    height: 100%;
    p {
      margin-top: 15px;
    }
  }
  .table-logs {
    display: block;
    font-size: 11px;
    overflow-x: auto;
    white-space: nowrap;
  }
</style>
